import React, { useState, useEffect } from "react";
import { confirmResetPassword, resetPassword } from "aws-amplify/auth";
import "./AdminLogin.css";

const ADMIN_EMAIL = "argencisupdates@gmail.com";

export default function ResetPassword() {
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  // TIMER STATES
  const [timer, setTimer] = useState(90); // 90-second countdown
  const [canResend, setCanResend] = useState(false);

  // ---------------- TIMER EFFECT ----------------
  useEffect(() => {
    if (timer <= 0) {
      setCanResend(true);
      return;
    }
    const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);

    return () => clearInterval(interval);
  }, [timer]);

  // ---------------- PASSWORD RULES ----------------
  const validatePassword = (pwd) => {
    const rules = [
      { test: /.{8,}/, msg: "At least 8 characters" },
      { test: /[A-Z]/, msg: "At least 1 uppercase letter" },
      { test: /[a-z]/, msg: "At least 1 lowercase letter" },
      { test: /\d/, msg: "At least 1 number" },
      { test: /[^A-Za-z0-9]/, msg: "At least 1 special character" }
    ];

    const failed = rules.filter((r) => !r.test.test(pwd));
    return failed.length === 0 ? null : failed.map((r) => r.msg).join(", ");
  };

  // ---------------- HANDLE PASSWORD RESET ----------------
  const handleReset = async () => {
    setMessage("");

    if (!code) {
      setMessage("Enter verification code.");
      return;
    }

    const pwdError = validatePassword(newPassword);
    if (pwdError) {
      setMessage("Password invalid: " + pwdError);
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    try {
      await confirmResetPassword({
        username: ADMIN_EMAIL,
        confirmationCode: code,
        newPassword
      });

      setMessage("Password reset successful. You may login now.");
      setIsSuccess(true);
    } catch (err) {
      console.log(err);
      setMessage(err.message || "Reset failed. Try again.");
    }
  };

  // ---------------- HANDLE RESEND CODE ----------------
  const handleResend = async () => {
    setMessage("");
    setCanResend(false);
    setTimer(90); // restart 90 sec timer

    try {
      await resetPassword({ username: ADMIN_EMAIL });
      setMessage("A new verification code has been sent.");
    } catch (err) {
      console.log(err);
      setMessage("Failed to resend code. Try again.");
      setCanResend(true); // allow retry
    }
  };

  return (
    <div className="login-page">
      <div className="glass-card login-card">

        <h2 className="login-title">Enter Reset Code</h2>

        {/* LOCKED ADMIN EMAIL */}
        <input
          type="email"
          className="login-input"
          value={ADMIN_EMAIL}
          disabled
        />

        {/* RESET CODE */}
        <input
          type="text"
          className="login-input"
          placeholder="Verification Code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          disabled={isSuccess}
        />

        {/* RESEND TIMER + BUTTON */}
        <div style={{ marginBottom: "12px", marginTop: "-6px" }}>
          {!canResend ? (
            <p style={{ fontSize: "13px", opacity: 0.7 }}>
              Resend code in {timer}s
            </p>
          ) : (
            <button
              className="login-btn"
              style={{
                padding: "10px",
                background: "#7f8db6",
                fontSize: "14px"
              }}
              onClick={handleResend}
              disabled={isSuccess}
            >
              Resend Code
            </button>
          )}
        </div>

        {/* NEW PASSWORD */}
        <input
          type="password"
          className="login-input"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          disabled={isSuccess}
        />

        {/* CONFIRM PASSWORD */}
        <input
          type="password"
          className="login-input"
          placeholder="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          disabled={isSuccess}
        />

        {/* RESET PASSWORD BUTTON */}
        <button
          className="login-btn"
          onClick={handleReset}
          disabled={isSuccess}
          style={{
            opacity: isSuccess ? 0.6 : 1,
            cursor: isSuccess ? "not-allowed" : "pointer",
            marginTop: "10px"
          }}
        >
          Reset Password
        </button>

        {/* MESSAGE + GO TO LOGIN */}
        {message && (
          <div style={{ marginTop: "12px" }}>
            <p
              style={{
                color: message.startsWith("Password reset") ? "green" : "#d9534f",
                marginBottom: "10px"
              }}
            >
              {message}
            </p>

            {isSuccess && (
              <button
                className="login-btn"
                onClick={() => (window.location.href = "/admin/login")}
              >
                Go to Login
              </button>
            )}
          </div>
        )}

      </div>
    </div>
  );
}
